var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkHelpChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9808 21.5288C17.741 21.5288 21.6 17.6698 21.6 12.9096C21.6 8.14934 17.741 4.2904 12.9808 4.2904C8.22052 4.2904 4.36157 8.14934 4.36157 12.9096C4.36157 17.6698 8.22052 21.5288 12.9808 21.5288Z",
    fill: "#E2D4F4",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0047 20.1608C8.59352 20.1608 6.31672 19.2112 4.59272 17.488C2.86952 15.7648 1.91992 13.4872 1.91992 11.076C1.91992 8.6648 2.86952 6.388 4.59272 4.664C6.31592 2.9408 8.59352 1.9912 11.0047 1.9912C13.4159 1.9912 15.6927 2.9408 17.4167 4.664C19.1399 6.3872 20.0895 8.6648 20.0895 11.076C20.0895 11.3408 19.8743 11.556 19.6095 11.556C19.3447 11.556 19.1295 11.3408 19.1295 11.076C19.1295 8.9216 18.2799 6.8856 16.7375 5.3432C15.1951 3.8008 13.1591 2.9512 11.0047 2.9512C8.85032 2.9512 6.81352 3.8008 5.27192 5.3432C3.72952 6.8856 2.87992 8.9216 2.87992 11.076C2.87992 13.2304 3.72952 15.2672 5.27192 16.8088C6.81432 18.3512 8.85032 19.2008 11.0047 19.2008C13.5239 19.2008 15.9399 18.0048 17.4671 16.0008C17.6279 15.7896 17.9287 15.7488 18.1399 15.9096C18.3511 16.0704 18.3911 16.3712 18.2311 16.5824C16.5239 18.8232 13.8223 20.1608 11.0055 20.1608H11.0047Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0047 16.32C10.6511 16.32 10.3647 16.0336 10.3647 15.68V10.02C10.3647 9.6664 10.6511 9.38 11.0047 9.38C11.3583 9.38 11.6447 9.6664 11.6447 10.02V15.68C11.6447 16.0336 11.3583 16.32 11.0047 16.32Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0047 8.0664C11.5079 8.0664 11.9159 7.65845 11.9159 7.1552C11.9159 6.65196 11.5079 6.244 11.0047 6.244C10.5015 6.244 10.0935 6.65196 10.0935 7.1552C10.0935 7.65845 10.5015 8.0664 11.0047 8.0664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkHelpChecked);
export default __webpack_public_path__ + "static/media/check-mark-help-checked.60cb4fe038f8b186fe3ffead3f6585d3.svg";
export { ForwardRef as ReactComponent };